import React from 'react'
import { FormControl, Grid, TextField, Typography } from '@mui/material'

export const DepositRefundSection = ({ useFetchInit }) => {
    const { 
        //------------- Generales
        // location,
        // paramsURL,
        //------------- globalStates
        globalStates,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        // Actions,
        //------------- helpers
        // Helpers,
        //------------- Formularios
        Forms
        
    } = useFetchInit

        // ------------------------------------------------ Formularios
        const { FormRequestGlobal } = Forms
        const { formState, onInputChange } = FormRequestGlobal

        const {formOpeningMode} = globalStates

        //------------------------------------------------- Fech data

        //------------------------------------------------- Actions

    return (
        <>
            <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                Informacion sobre la gestion
            </Typography>
            <div className="border-bottom border-dark"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="deposito_total"> Total Deposito</label>
                        <TextField
                            id='deposito_total'
                            name='deposito_total'
                            value={ formState.deposito_total } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Deposito Total'
                            type='text'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="cargos_extras_total"> Total Cargos Extras</label>
                        <TextField
                            id='cargos_extras_total'
                            name='cargos_extras_total'
                            value={ formState.cargos_extras_total } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Total Cargos Extras'
                            type='text'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="monto_devolucion"> Monto Solicitado</label>
                        <TextField
                            id='monto_devolucion'
                            name='monto_devolucion'
                            value={ formState.monto_devolucion } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Monto Solicitado'
                            type='number'
                            variant='outlined'
                            InputProps={{
                                readOnly: false 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="gestion_descripcion">Descripcion</label>
                        <TextField
                            id='gestion_descripcion'
                            name='gestion_descripcion'
                            value={ formState.gestion_descripcion } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Descripcion'
                            type='text'
                            multiline
                            rows={5}
                            variant={(formOpeningMode==='READONLY')? 'filled': 'outlined'}
                            InputProps={{
                                readOnly: (formOpeningMode==='READONLY') ? true: false 
                            }}
                            
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </>
    )
}
